/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VariableSubscriptionResponseDTO { 
    subscriberId?: string;
    variableId?: string;
    organizationId?: string;
    subscribed?: boolean;
    changed?: boolean;
}

